export default __webpack_public_path__ + "static/media/plisse.846767ef.jpg";